<template>
  <div class="flex items-center mr-4 search-wrapper">
    <el-input
      v-model="search"
      placeholder="搜索"
      @keyup.enter.native="handleSearch"
    />
    <el-button
      type="primary"
      icon="el-icon-search"
      @click="handleSearch"
    ></el-button>
  </div>
</template>

<script>
import { Message, Button, Input } from "element-ui";

export default {
  name: "MySearch",
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
  },
  data() {
    return {
      search: "",
    };
  },
  methods: {
    handleSearch() {
      if (this.search) {
        this.$router.push({
          name: "search",
          query: {
            q: this.search,
          },
        });
      } else {
        Message.warning("请输入要搜索的关键字");
      }
    },
  },
  created() {
    this.search = this.$route.query.q;
  },
};
</script>

<style lang="scss" scoped>
.search-wrapper {
  ::v-deep  .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ::v-deep .el-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
